__turbopack_context__.v({
  "backToTopContainer": "AllPrizesByTier-module__CC_Kla__backToTopContainer",
  "groupingContainer": "AllPrizesByTier-module__CC_Kla__groupingContainer",
  "introParagraph": "AllPrizesByTier-module__CC_Kla__introParagraph",
});
